import { render } from "./500.vue?vue&type=template&id=2919925c&scoped=true"
const script = {}

import "./500.vue?vue&type=style&index=0&id=2919925c&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-2919925c"

export default script